<template>
  <span>Всего: {{ amount }}</span>
</template>

<script>
  export default {
    props: ['amount'],
    name: "TableSummaryAmountLabel"
  }
</script>

<style scoped>
  span {
    color: #666;
    font-size: 11px;
    margin-bottom: 2px;
  }
</style>

